import { call, put } from 'redux-saga/effects';

import { takeLatest } from '../../../utils/reduxSaga';
import { URLS } from '../../../consts/endpoints';
import { actions as sagaActions, LOCK_USER } from './types';
import RESPONSE_CODES from '../../../consts/responseCodes';
import showSnackbar from '../../../utils/showSnackbar';
import { getData, postData } from '../../../utils/http';
import { actions as reduxActions } from '../reducers';
import urlCreator from '../../../utils/urlCreator';

export function lockUserAction(userId, action) {
  return {
    type: sagaActions[LOCK_USER],
    userId,
    action
  };
}

export function* lockUser({ userId, action }) {
  const intlTextKey =
    action === 'lock' ? 'MESSAGE.USER_LOCKED' : 'MESSAGE.USER_UNLOCKED';

  const response = yield call(postData, {
    url: `${URLS.USERS}/${userId}/${action}`,
    data: {}
  });

  if (response.status === RESPONSE_CODES.SUCCESS) {
    yield call(showSnackbar, {
      intlTextKey,
      messageType: 'success'
    });

    const { data } = yield call(
      getData,
      urlCreator(`${URLS.USERS}/${userId}.json`, {})
    );
    
    yield put(reduxActions.refreshUser(data));
  }
}

function* watchLockUser() {
  yield takeLatest(sagaActions[LOCK_USER], lockUser);
}

export default watchLockUser();
